import { ChevronSmallLeftIcon as ChevronLeftBoldIcon } from "@wags/ui/product-icons.tsx";

import { Link } from "@tanstack/react-router";
import { cn } from "@wags/ui/ui-utils";

type SettingsBackLinkTarget =
    | { to: "/profile" | "/settings"; href?: never }
    | { href: string; to?: never };

export function SettingsBackLink({
    label,
    className,
    "aria-label": ariaLabel,
    ...target
}: SettingsBackLinkTarget & {
    label: string;
    className?: string;
    "aria-label"?: string;
}) {
    const linkClassName = cn(
        "-ml-1 inline-flex min-h-11 w-fit items-center gap-1.5 rounded-nested py-1 pr-2 text-[15px] font-medium leading-[18px] text-doberman-black/55 outline-none transition-colors motion-reduce:transition-none [@media(hover:hover)]:hover:text-doberman-black focus-visible:ring-2 focus-visible:ring-labrador-yellow focus-visible:ring-offset-2 focus-visible:ring-offset-maltese-white",
        className,
    );
    const content = (
        <>
            <ChevronLeftBoldIcon className="size-5" />
            {label}
        </>
    );
    if (target.href !== undefined) {
        return (
            <a
                href={target.href}
                aria-label={ariaLabel}
                className={linkClassName}
            >
                {content}
            </a>
        );
    }
    return (
        <Link to={target.to} aria-label={ariaLabel} className={linkClassName}>
            {content}
        </Link>
    );
}
